import { c as e } from "../../index-226b8ea6.js";
const [r, t] = e({
  name: "SharedFooterStylesContext",
  errorMessage: `useSharedFooterStyles returned is 'undefined'. Seems you forgot to wrap the components in "<SharedFooter />" `
});
export {
  r as SharedFooterStylesProvider,
  t as useSharedFooterStyle
};
//# sourceMappingURL=SharedFooter.context.es.js.map
